exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__OperationNotAllowed__title__3gtEh {\n  margin-bottom: 20px;\n}\n\n.dmb-web__OperationNotAllowed__buttonContainer__24tE6 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n", ""]);

// exports
exports.locals = {
	"title": "dmb-web__OperationNotAllowed__title__3gtEh",
	"buttonContainer": "dmb-web__OperationNotAllowed__buttonContainer__24tE6"
};